import once from 'transmute/once';
import DSFieldRecord from '../../../filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { PROPERTY_CHANGED_NAME_AND_VALUE } from '../../../filterQueryFormat/UnifiedEventPropertyTypes';
export default once(() => DSFieldRecord({
  name: 'property_name_and_value',
  label: 'Property name and value',
  type: PROPERTY_CHANGED_NAME_AND_VALUE
}));